import React from 'react'
import footer_image from '../../assets/images/footer_image.png'
const Footer = () => {
  return (
    <>
    <footer className='mt-2.5 pt-2.5 w-full mx-auto bg-charcoal hidden lg:block'>
        <img src={footer_image} alt="" className='block mb-2.5 w-full'/>
        <div className='h-[95px] border border-slate '>
         <div className='text-center text-xs pt-10 text-silver'><span> Copyright ⓒ2015 <strong>나루토카지노</strong>  All rights reserved </span>  </div>
        </div>
    </footer>
    </>
  )
}

export default Footer